import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { Input, SelectField, fieldRow } from "./FormField";
import { useWatch } from "react-hook-form";

const DIMENSION_OPTIONS = {
    hiloItems: [
        { value: "Si", label: "Sí" },
        { value: "No", label: "No" }
    ],

    flautaItems: [
        { value: "A", label: "A" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "E", label: "E" },
        { value: "F", label: "F" }
    ]
}

const DimensionAndTolerance = ({theme, control}) => {

    const format = useWatch({control, name: "format"}); //Get the value of the format parameter

    return(
        <Col style={{width: '100%', alignItems: 'start', marginTop: 64}}>
            <Text size={15} color={theme.Black} weight={"extrabold"}>Dimensiones y tolerancia</Text>
            {format === "Caja" ? (
                <Col style={{width: '100%', justifyContent: 'space-between'}}>
                    <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                        <Input theme={theme} control={control} name="flatSize" label="Medida extendida" suffix="mm"/>
                        <Input theme={theme} control={control} name="finalSize" label="Medida final" suffix="mm"/>
                        <SelectField theme={theme} control={control} name="chain" label="Hilo" options={DIMENSION_OPTIONS.hiloItems}/>
                        <SelectField theme={theme} control={control} name="flute" label="Flauta" options={DIMENSION_OPTIONS.flautaItems}/>
                    </Row>
                    <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                        <Input theme={theme} control={control} name="front" label="Frente" suffix="mm"/>
                        <Input theme={theme} control={control} name="side" label="Lateral" suffix="mm"/>
                        <Input theme={theme} control={control} name="height" label="Altura" suffix="mm"/>
                        <Input theme={theme} control={control} name="tolerance" label="Tolerancia" prefix="+/-"/>
                    </Row>
                </Col>
            ) : (
                <Col style={{width: '100%', justifyContent: 'space-between'}}>
                    <Row style={{...fieldRow, width: '100%', marginTop: 16}}>
                        <Input theme={theme} control={control} name="flatSize" label="Medida extendida" suffix="mm"/>
                        <Input theme={theme} control={control} name="finalSize" label="Medida final" suffix="mm"/>
                        <Input theme={theme} control={control} name="tolerance" label="Tolerancia" prefix="+/-"/>
                    </Row>
                </Col>
            )}
        </Col>
    )
}

export default DimensionAndTolerance;